export enum RestaurantDetailSectionId {
    DEALS = 'deals',
    REWARDS = 'rewards',
    MENU = 'menu',
    REVIEWS = 'reviews',
    OPENING_HOURS = 'opening-hours',
    LOCATION = 'location',
    CONTACT = 'contact',
}
